import { render } from "./ai-form-text-box.vue?vue&type=template&id=6cf201fe"
import script from "./ai-form-text-box.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-form-text-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/card-component/ai-form-text-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cf201fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cf201fe', __exports__)) {
    api.reload('6cf201fe', __exports__)
  }
  
  module.hot.accept("./ai-form-text-box.vue?vue&type=template&id=6cf201fe", () => {
    api.rerender('6cf201fe', render)
  })

}


export default __exports__